import React from 'react'
import { DropdownItem } from 'util/ui'
import MergeDropdown from '../../MergeDropdown'

const MergeDropdownOption = React.memo(props => {
  return (
    <DropdownItem
      data-test-id="MoreMenuMergeTicketOption"
      aria-checked="false"
      {...props}
    >
      <MergeDropdown open trigger={'Merge'} />
    </DropdownItem>
  )
})

export default MergeDropdownOption
